import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const BillingCounterList = lazy(() => import('../Pages/BillingCounterList'));
const AddBillingCounter = lazy(() => import('../Pages/BillingCounterAdd'));
const EditBillingCounter = lazy(() => import('../Pages/BillingCounterEdit'));
const BillingCounterView = lazy(() => import('../Pages/BillingCounterView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/billing-counter.scss';

function BillingCounterRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/settings/billing-counters"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <BillingCounterList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/billing-counters/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <BillingCounterList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/billing-counters/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <AddBillingCounter history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/billing-counters/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <EditBillingCounter history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/settings/billing-counters/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <BillingCounterView history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default BillingCounterRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
